/*
 * @Description: 权限相关接口
 * @Date: 2022-04-21 16:07:44
 * @LastEditTime: 2023-04-27 16:41:17
 */
import { Request } from "@/plugin/axios";
import api from "@/constant/api/console/model/auth";

// 校验token
export function checkToken(params) {
  return Request(api.checkToken, api.checkToken.url, params);
}

// 角色按钮资源Code查询
export function queryButtonCode(params) {
  return Request(api.queryButtonCode, api.queryButtonCode.url, params);
}

export function queryMenu(params) {
  return Request(api.queryMenu, api.queryMenu.url, params);
}
export function instanceList() {
  return Request(api.instanceList, api.instanceList.url).then((res) => {
    if (res?.data) return res.data;
    else return [];
  });
}
